const acceptable_jobName_regEx = /^[A-Za-z0-9\_\-\.\@\# ]+$/;
const acceptable_meterSerialNum_regEx = /^[A-Za-z0-9 _]+$/;

export const validateJobName = (jobName) => {
  if (jobName.length == 0) {
    return "Missing required field 'Job Name'.";
  }
  if (!acceptable_jobName_regEx.test(jobName)) {
    return `Job Name is invalid. Can only contain letters, numbers, characters like _ . @ # and spaces.`;
  }
  if (jobName.length < 5) {
    return "Job Name is too short. Cannot be shorter than 5 characters.";
  }
  if (jobName.length > 200) {
    return "Job Name is too long. Cannot be longer than 200 characters.";
  }
};

export const validateCallbackUrl = (jobCallbackUrl) => {

  try {
    const u = new URL(jobCallbackUrl);
    return (
      (u.protocol === "http:" || u.protocol === "https:")
    );
  } catch (e) {
    return false;
  }
}

export const validateMeterSerialInput = (meterSerialNums) => {

  const serialNums = meterSerialNums.split(",");

  if(serialNums.length === 1){
    if (serialNums[0].length < 3) {
      return `Serial number(${serialNums[0]}) length should be 3 minimum`;
    }

    if (!acceptable_meterSerialNum_regEx.test(serialNums[0])) {
      return `Meter ID(${serialNums[0]}) does not comply with the specified validation rules`;
    }
  }

  if(serialNums.length > 1){
    for (let i = 0; i < serialNums.length; i++) {
      const meter = serialNums[i];
      if (meter.length < 3) {
        return `Serial number(${meter}) length should be 3 minimum`;
      }

      if (!acceptable_meterSerialNum_regEx.test(meter)) {
        return `Meter ID(${meter}) does not comply with the specified validation rules`;
      }
    }
  }
};

